import { Component, Fragment } from "react";
import {
    DKLabel,
    DKButton,
    DKLine,
    DKIcons,
    DKIcon,
    DKListPicker,
    DKSpinner,
    showAlert,
    showToast,
    TOAST_TYPE,
    DKListPicker2,
    INPUT_TYPE,
    DKInput
} from "deskera-ui-library";
import EmailEditor from "../../email_editor/EmailEditor_Quill";
import { CampaignService } from "../../../services/campaign";
import Utility from "../../../utility/Utility";
import debounce from "../../../utility/Debounce";
import UserManager from "../../../managers/UserManager";
import SMTPService from "../../../services/smtp";
import SmtpPopup from "../../campaign/SmtpPopup";
import { AUTOMATION_TRIGGERS, EMAIL_COMPOSER_DIMENSIONS } from "../AutomationConstants";
import { COLUMN_CODE, TableManger, TABLES, TABLE_DISPLAY_NAME } from "../../../managers/TableManger";
import { CAMPAIGN_TYPE, FILTER_OPERATORS, LOCAL_STORAGE_KEYS } from "../../../constants/Enums";
import PageDesigner from "../../page_designer/PageDesigner";
import { PAGE_TYPE } from "../../page_designer/ComponentList";
import ApiConstants from "../../../constants/ApiConstants";
import RouteManager, { PAGE_ROUTES } from "../../../managers/RouteManager";
import Table from "../../../services/table";
import HtmlGenerator from "../../page_designer/HtmlGenerator";
import LandingPageManager from "../../landing_pages/LandingPageManager";
import LandingPageService from "../../../services/landingPage";
import ComponentManager from "../../page_designer/ComponentManager"
import EmailTemplate1 from "../../email-template/basicEmailTemplates/Template1";
import { decodeBase64Uri } from "../../../managers/common/CommonUtil";
/*
PROPS
- stepData
- onClose
- onSave
*/

class EmailComposer extends Component {
  pageDataToSave = null;
  htmlData = "";
  constructor(props) {
    super(props);
    this.data =
      this.props.stepData && this.props.stepData.configuration
        ? this.props.stepData.configuration
        : null;
    this.default_fromName = UserManager.getUserDetails()?.name || "Deskera Team";
    this.default_fromEmail = this.props.default_fromEmail || UserManager.getUserEmail() || "team@deskera.com";
    this.default_subject = "Welcome to Deskera!";
    this.default_recipient = this.props.emailToOptions?.length ? this.props.emailToOptions[0]?.id : null;
    this.default_user_recipient = this.props.userList?.length ? [this.props.userList[0]?.iamUserId] : null;
    this.default_body = EmailTemplate1.getTemplate();
    this.default_smtp_setup_id = "0";
    this.campaignNameColId = TableManger.getColumnId(
      TABLES.CAMPAIGN,
      COLUMN_CODE.CAMPAIGN.NAME
    );
    this.landingPagesColId = TableManger.getColumnId(
      TABLES.PEOPLE_EMAIL_TEMPLATE,
      COLUMN_CODE.PEOPLE_EMAIL_TEMPLATE.NAME
    );
    this.campaignJsonColId = TableManger.getColumnId(
      TABLES.CAMPAIGN,
      COLUMN_CODE.CAMPAIGN.JSON_DATA
    );
    this.landingPagesJsonColId = TableManger.getColumnId(
      TABLES.PEOPLE_EMAIL_TEMPLATE,
      COLUMN_CODE.PEOPLE_EMAIL_TEMPLATE.JSON_DATA
    );
    this.campaignTableId = TableManger.getTableId(TABLES.CAMPAIGN);
    this.landingPageTableId = TableManger.getTableId(TABLES.PEOPLE_EMAIL_TEMPLATE);
    this.triggerType = this.props.triggerType
    
    this.state = {
      isEmailVerified: false,
      emailBeingVerified: true,
      verificationMailSent: false,
      smtpOptions: [],
      smtpDataToEdit: null,
      needSMTPPicker: false,
      needRecipientPicker: false,
      needRecipientUserPicker: false,
      selectedUserIndex: [0],
      data: {
        fromName:
          this.data && this.data.fromName
            ? this.data.fromName
            : this.default_fromName,
        fromEmail:
          this.data && this.data.fromEmail
            ? this.data.fromEmail
            : this.default_fromEmail,
        recipientType: this.data?.recipientType || this.default_recipient,
        recipientIamUserIds: this.data?.recipientIamUserIds || this.default_user_recipient,
        subject:
          this.data && this.data.subject
            ? this.data.subject
            : this.default_subject,
        body: this.data && this.data.body ? this.data.body : this.default_body,
        campaignSetupId:
          this.data && this.data.campaignSetupId
            ? this.data.campaignSetupId
            : this.default_smtp_setup_id,
        bodySrcRecordId: this.data?.bodySrcRecordId || null,
        bodySrcObjectType: this.data?.bodySrcObjectType || null,
      },
      toggleListPicker: false,
      showListPicker: false,
      templateData: [],
      selectedTemplateJson: {},
      selectedTemplateName: '',
      pageDesignerReadOnly: true,
      emailTemplateList: [],
      selectedEmailTemplateName: '',
      selectedTemplateId: this.data?.selectedTemplateId || null
    };
  }
  componentDidMount() {
    this.getEmailVerification(this.state.data["fromEmail"], this.state.data.campaignSetupId && this.state.data.campaignSetupId !== this.default_smtp_setup_id);
    this.getAllSMTPData();
    this.getEmailTemplate()
    if (this.props.stepData && this.props.stepData.configuration && this.props.stepData.configuration.recipientIamUserIds) {
      let findIndex = []
      this.props.stepData.configuration.recipientIamUserIds?.forEach((key => {
        let index = this.props.userList.findIndex((user) => user.iamUserId === key)
        if (index !== -1) {
          findIndex.push(index)
        }
      }));
      this.setState({ selectedUserIndex: findIndex });
    }
    
    if (
      this.props.stepData &&
      this.props.stepData.configuration &&
      this.props.stepData.configuration.bodySrcRecordId &&
      this.props.stepData.configuration.bodySrcObjectType
    ) {
      let jsonData = "",
        templateName = "";
      if (
        this.props.stepData.configuration.bodySrcObjectType ===
        TABLES.CAMPAIGN.toUpperCase()
      ) {
        let campaignCell =
          this.props.campaign?.find(
            (data) =>
              data.cells["id"] ===
              this.props.stepData.configuration.bodySrcRecordId
          ) || "";
        if (Utility.isEmptyObject(campaignCell)) {
          this.getTemplateRecordById(
            TABLES.CAMPAIGN,
            this.props.stepData.configuration.bodySrcRecordId,
            this.campaignJsonColId,
            this.campaignNameColId
          );
        } else {
          jsonData = campaignCell.cells[this.campaignJsonColId] || {};
          templateName = campaignCell.cells[this.campaignNameColId] || "";
          this.updateSelectedTemplate(jsonData, templateName);
        }
      }
      if (
        this.props.stepData.configuration.bodySrcObjectType ===
        TABLES.PEOPLE_EMAIL_TEMPLATE.toUpperCase()
      ) {
        let landingPageCell =
          this.props.landingPages?.find(
            (data) =>
              data.cells["id"] ===
              this.props.stepData.configuration.bodySrcRecordId
          ) || "";
        if (Utility.isEmptyObject(landingPageCell)) {
          this.getTemplateRecordById(
            TABLES.PEOPLE_EMAIL_TEMPLATE,
            this.props.stepData.configuration.bodySrcRecordId,
            this.landingPagesJsonColId,
            this.landingPagesColId
          );
        } else {
          jsonData = landingPageCell.cells[this.landingPagesJsonColId] || {};
          templateName = landingPageCell.cells[this.landingPagesColId] || "";
          this.updateSelectedTemplate(jsonData, templateName);
        }
      }
    }
  }
  getEmailTemplate() {
    let req = {
      pageNo: 1,
      pageSize: 100,
      q: "",
    };
    const statusColId = TableManger.getColumnId(
      TABLES.PEOPLE_BASIC_EMAIL_TEMPLATE,
      COLUMN_CODE.PEOPLE_BASIC_EMAIL_TEMPLATE.STATUS
    )
    let payload = {"logicalOperator":"and","conditions":[{"colId":statusColId,"value":[1],"opr":"c"}]}
    Table.getRecordsByPage(req, payload,TableManger.getTableId(TABLES.PEOPLE_BASIC_EMAIL_TEMPLATE) )
      .then((res) => {
        let emailTemplate = []
        if(res && res.data) {
          res.data.forEach((row,index)=>{
            const templateObj = {
              id: row._id,
              name: row.cells[TableManger.getColumnId(
                TABLES.PEOPLE_BASIC_EMAIL_TEMPLATE,
                COLUMN_CODE.PEOPLE_BASIC_EMAIL_TEMPLATE.NAME
              )],
              mailBody: row.cells[TableManger.getColumnId(
                TABLES.PEOPLE_BASIC_EMAIL_TEMPLATE,
                COLUMN_CODE.PEOPLE_BASIC_EMAIL_TEMPLATE.HTML_DATA
              )],
              active: row.cells[TableManger.getColumnId(
                TABLES.PEOPLE_BASIC_EMAIL_TEMPLATE,
                COLUMN_CODE.PEOPLE_BASIC_EMAIL_TEMPLATE.STATUS
              )],
              default: row.cells[TableManger.getColumnId(
                TABLES.PEOPLE_BASIC_EMAIL_TEMPLATE,
                COLUMN_CODE.PEOPLE_BASIC_EMAIL_TEMPLATE.DEFAULT
              )]
            }
            emailTemplate.push(templateObj)
          })
          this.setState({
            emailTemplateList: emailTemplate,
            selectedEmailTemplateName: emailTemplate.find(e=>e.id==this.state.selectedTemplateId)?.name || 'Default Template'
          })
        }
      })
  }

  updateSelectedTemplate = (jsonData, templateName) => {
    this.onSelectMailType(this.props.stepData.configuration.bodySrcObjectType);
  };

  getTemplateRecordById = (tableName, recordId, jsonColId, nameColId) => {
    const params = {
      pageNo: 1,
      pageSize: 1000
  };
    Table.getRecordById(
      recordId,
      TableManger.getTableId(TABLES.PEOPLE_EMAIL_TEMPLATE)
      ).then((res) => {
        if (res) {
          let data = res;
          let recordData = { ...data, [data.cells.id]: data._id };
          let jsonData = recordData.cells[jsonColId] || {};
          let templateName = recordData.cells[nameColId] || "";
          let templateRecords = [...this.state.templateData];
          templateRecords.push(recordData);
          this.setState({ templateData: templateRecords });
          this.updateSelectedTemplate(jsonData, templateName);
        }
      });
  };
  render() {
    return (
      <div className="transparent-background">
        <div
          className={`column popup-window email-composer`}
          style={{
            padding: 0,
            width: EMAIL_COMPOSER_DIMENSIONS.width,
            height: EMAIL_COMPOSER_DIMENSIONS.height,
            maxWidth: "90vw",
            maxHeight: "100vh",
          }}
        >
          {this.renderHeader()}
          {this.renderTopSection()}
          {this.renderBody()}
          {this.renderBottom()}
        </div>
      </div>
    );
  }

  ////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////

  renderHeader() {
    return (
      <div
        className="row justify-content-between pt-s pb-s bg-gray3 p-h-m"
        style={{ height: EMAIL_COMPOSER_DIMENSIONS.fieldHeight }}
      >
        <DKLabel text="New Message" className="fw-m" />
        <DKButton
          icon={DKIcons.ic_close}
          className=""
          onClick={this.props.onClose}
        />
      </div>
    );
  }

  renderBottom() {
    return (
      <div className="row-reverse pb-l p-h-m mt-m" style={{ height: 60 }}>
        <DKButton
          title={this.props.successButtonTitle || "Save"}
          className="bg-button text-white ml-m"
          onClick={() => {
            let { recipientType, recipientIamUserIds, campaignSetupId, bodySrcObjectType, bodySrcRecordId, ...dataToSave } = this.state.data;

            if (dataToSave.fromName.trim() === "") {
              dataToSave.fromName = this.default_fromName;
            }
            if (dataToSave.fromEmail.trim() === "") {
              dataToSave.fromEmail = this.default_fromEmail;
            }
            if (dataToSave.subject.trim() === "") {
              dataToSave.subject = "(no subject)";
            }
            if (recipientType) {
              dataToSave.recipientType = recipientType;
            }
            // if (recipientType === EMAIL_RECIPIENTS.ORG_USER && recipientIamUserIds.length === 0) {
            //   showToast("Please select users", TOAST_TYPE.FAILURE);
            //   return
            // }
            // if (recipientType === EMAIL_RECIPIENTS.ORG_USER && recipientIamUserIds.length !== 0) {
            //   dataToSave.recipientIamUserIds = recipientIamUserIds;
            // }
            if(campaignSetupId && campaignSetupId !== this.default_smtp_setup_id) {
              dataToSave.campaignSetupId = campaignSetupId;  
            }
            // if (!Utility.isEmptyObject(bodySrcObjectType) && Utility.isEmptyObject(bodySrcRecordId)) {
            //   showToast("Please select template", TOAST_TYPE.FAILURE);
            //   return
            // }else{
            //   dataToSave.bodySrcObjectType = bodySrcObjectType;
            //   dataToSave.bodySrcRecordId = bodySrcRecordId;
            // }
            // dataToSave.bodySrcObjectType = bodySrcObjectType;
            //   dataToSave.bodySrcRecordId = bodySrcRecordId;
            if (this.state.isEmailVerified) {
              const div_body = document.getElementById("mail-editor-body");
              dataToSave["body"] = this.getDataToSave(div_body);
              dataToSave['selectedTemplateId'] = this.state.selectedTemplateId;
              this.props.onSave(dataToSave);
              this.props.onClose();
            } else {
              showToast("Please verify your email", TOAST_TYPE.FAILURE);
            }
          }}
        />

        <DKButton
          title="Cancel"
          className="bg-gray1 border-m"
          onClick={this.props.onClose}
        />
      </div>
    );
  }

  renderTopSection() {
    return (
      <div className="parent-width">
        <DKLine />
        {this.renderInputField("From Name", "fromName")}
        <DKLine />
        {this.renderInputField("From Email", "fromEmail")}
        {this.renderRecipients("Recipient", "recipientType")}
        <DKLine />
        {this.renderInputField("Subject", "subject")}
        <DKLine />
      </div>
    );
  }

  renderInputField(title, valueKey) {
    const height = EMAIL_COMPOSER_DIMENSIONS.fieldHeight;
    return (
      <div className="row p-h-r" style={{ height }}>
        <DKLabel text={title} className="text-wrap-none text-gray" />
        <input
          value={this.state.data[valueKey]}
          className="flex-1 ml-m border-none fs-r"
          style={{ outline: "none", height: height - 3 }}
          onChange={(e) => {
            this.dataChanged(e.target.value, valueKey);
          }}
        />
        {this.getEmailVerificationView(valueKey)}
        {this.getSMTPSetupView(valueKey)}
      </div>
    );
  }
  toggleRecipientPicker = (shouldOpen) => {
    this.setState((prevState) => ({
      needRecipientPicker: shouldOpen ?? !prevState.needRecipientPicker
    }));
  }

  toggleRecipientUserPicker = (shouldOpen) => {
    this.setState((prevState) => ({
      needRecipientUserPicker: shouldOpen ?? !prevState.needRecipientUserPicker
    }));
  }

  renderRecipients(title, valueKey) {
    const options = this.props.emailToOptions;
    const height = EMAIL_COMPOSER_DIMENSIONS.fieldHeight;
    return Utility.isEmptyObject(options) ? null : (
        <Fragment>
            <DKLine />
            <div className="row p-h-r" style={{ height }}>
                <DKLabel text={title} className="text-wrap-none text-gray" />
                <div className="position-relative">
                    <DKButton
                        className="ml-m border-none fs-r bg-chip-gray"
                        style={{ padding: 8 }}
                        title={options.find(option => option.id === this.state.data.recipientType)?.name}
                        icon={DKIcons.ic_arrow_down2}
                        isReverse={true}
                        onClick={() => this.toggleRecipientPicker()}
                    />
                    {this.state.needRecipientPicker && (
                        <DKListPicker
                            data={options.map(option => option.name)}
                            className="position-absolute border-m border-radius-m shadow-s z-index-3"
                            style={{ left: 16, top: 0, minWidth: 150 }}
                            onSelect={(index, optionName) => {
                                this.dataChanged(options[index].id, valueKey);
                                this.toggleRecipientPicker(false);
                            }}
                            onClose={() => this.toggleRecipientPicker(false)}
                        />
                    )}
                </div>
            </div>
        </Fragment>
    );
}

  getEmailVerificationView(valueKey) {
    if (valueKey === "fromEmail") {
      // const isInvalidEmail = Utility.isValidEmail(this.state.data[valueKey]);
      return (
        <>
          {this.state.isEmailVerified ? (
            <div class="d-flex align-items-center">
              <DKLabel text="✓ Email Verified" className="fs-r text-green" />
            </div>
          ) : this.state.emailBeingVerified ? (
            <DKSpinner iconClassName="ic-s" />
          ) : this.state.verificationMailSent ? (
            <div
              className="d-flex align-items-center cursor-hand bg-gray1 p-h-xs p-v-xs border-radius-m"
              onClick={() =>
                this.getEmailVerification(this.state.data["fromEmail"])
              }
            >
              <DKIcon src={DKIcons.ic_repeat} className="ic-s mr-xs" />
              <DKLabel text="Refresh" className="fs-r" />
            </div>
          ) : (
            <div
              className="d-flex align-items-center cursor-hand text-red"
              onClick={() => this.sendVerificationEmail()}
            >
              <DKLabel text="Verify Email" className="fs-r" />
            </div>
          )}
        </>
      );
    }
  }
  ////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////

  dataChanged(newValue, valueKey, isSMTPEmail) {
    let data_new = this.state.data;
    data_new[valueKey] = newValue;
    this.setState({ data: data_new });
    if (valueKey === "fromEmail") {
      this.getEmailVerification(newValue, isSMTPEmail);
    }
  }

  replacePlaceholders(editor_body) {
    const placeholders = editor_body.getElementsByClassName(
      "custom_email_placeholder"
    );
    Array.from(placeholders).forEach((placeholder) => {
      const dataId = placeholder.getAttribute("data-id");
      placeholder.innerHTML = `%${dataId}%`;
    });

    return editor_body.innerHTML;
  }

  getDataToSave(editor_container) {
    /* picking contents from inner element for handling quill editor */
    const editor_body = editor_container.querySelector(".ql-editor");
    const html_text = editor_body
      ? this.replacePlaceholders(editor_body)
      : editor_container.innerHTML;

    /* sanitize text for email placeholders */
    return html_text;
  }

  ////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////

  toggleList = (value = false) => {
    this.setState({
      toggleListPicker: value,
    });
  };
  toggleEditEmailTemplate() {
    if(!Utility.isEmpty(this.state.data.bodySrcObjectType) && this.state.showListPicker && this.state.selectedTemplateName) {
      return true;
    } else {
      return false;
    }
  }
  renderBody() {
    const editorHeight = EMAIL_COMPOSER_DIMENSIONS.editorHeight - (Utility.isEmptyObject(this.props.emailToOptions) ? 0 : EMAIL_COMPOSER_DIMENSIONS.fieldHeight);
    let tableName = this.props.emailToOptions?.find((option) => option.id === this.state.data?.recipientType)?.tableName;
    let additionalPlaceholders = [];

    // if([EMAIL_RECIPIENTS.OWNER, EMAIL_RECIPIENTS.ORG_USER].includes(this.state.data?.recipientType)) {
    //   additionalPlaceholders = [...additionalPlaceholders, ...EMAIL_USER_PLACEHOLDERS];

    //   if(this.props.triggerType === AUTOMATION_TRIGGERS.DEAL_STAGE_CHANGED) {
    //     additionalPlaceholders = [...additionalPlaceholders, ...DEAL_STAGE_CHANGE_PLACEHOLDERS];
    //   }
    // }
    if(this.props.triggerType === AUTOMATION_TRIGGERS.PEOPLE_DATE_ALERT) {
        additionalPlaceholders = [{id:"name", value: "employeeName"}]
        tableName = this.props?.tableName
    } else if (this.props.triggerType === AUTOMATION_TRIGGERS.PEOPLE_EMPLOYEE_ADDED) {
        tableName = this.props?.tableName
    }
    
    return (
      <div className="column parent-width">
        <div className="row mt-s mb-s">
          <div>
            <DKButton
              icon={DKIcons.data_type.ic_text}
              title="Text"
              className={`ml-m border-radius-none ${
                this.state.data.bodySrcObjectType === null
                  ? "active-border"
                  : ""
              }`}
              onClick={() => this.onSelectMailType(null)}
            />
          </div>
          {/* Note this will use in future */}
          {/* <div className="column">
            {!Utility.getPersistentValue(
              LOCAL_STORAGE_KEYS.NEW_EMAIL_AUTOMATION_LANDING_PAGE
            ) && this.getNewBatch()}
            <DKButton
              icon={DKIcons.ic_document}
              title="Email Templates"
              className={`border-radius-none position-relative ${
                this.state.data.bodySrcObjectType ===
                TABLES.PEOPLE_EMAIL_TEMPLATE.toUpperCase()
                  ? "active-border"
                  : ""
              }`}
              onClick={() => {
                this.onSelectMailType(TABLES.PEOPLE_EMAIL_TEMPLATE.toUpperCase());
                if (
                  Utility.isEmptyObject(
                    Utility.getPersistentValue(
                      LOCAL_STORAGE_KEYS.NEW_EMAIL_AUTOMATION_LANDING_PAGE
                    )
                  )
                ) {
                  Utility.setPersistentValue(
                    LOCAL_STORAGE_KEYS.NEW_EMAIL_AUTOMATION_LANDING_PAGE,
                    1
                  );
                }
              }}
            />
          </div> */}
          
          { this.getEmailListPicker()}
          
        </div>

          <EmailEditor
            editorID="mail-editor-body"
            body={this.state.data.body}
            height={editorHeight}
            tableName={tableName}
            additionalPlaceholders={additionalPlaceholders}
            selectedTemplateId={this.state.selectedTemplateId}
            triggerType={this.triggerType}
          />
      </div>
    );
  }
  updatePage() {
    const request = LandingPageManager.getRequestToUpdatePage(
      ComponentManager.getEncodedDataToSave(this.pageDataToSave, PAGE_TYPE.PEOPLE_EMAIL_TEMPLATE)
    );
    LandingPageService.update(
      request,
      LandingPageManager.getPageRecordId(),
      (data) => {
        LandingPageManager.setPageData(data);
        showToast("Email Template updated successfully.",TOAST_TYPE.SUCCESS);
        this.setState({
          pageDesignerReadOnly: true
        })
      },
      (error) => {
        showToast("Unable to update Email Template.",TOAST_TYPE.FAILURE)
      }
    );
  }
  
  ////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////
  sendVerificationEmail(resend = false) {
    if (!Utility.isValidEmail(this.state.data["fromEmail"])) {
      showAlert(
        'Error occurred!',
        'Enter valid email address'
      );
      return
    }
    CampaignService.sendVerificationEmail(
      this.state.data["fromEmail"],
      resend
    ).then(
      (data) => {
        this.showVerificationSent();
      },
      (err) => {
        if (err.code === 400 && err.crmErrorCode === "CRM_001" && err.errorMessage !== 'Enter valid email address') {
          this.showVerificationSent(err.errorMessage);
        }
      }
    );
  }

  getEmailVerification = debounce((email, isSMTPEmail = false) => {
    if (this.state.data.fromEmail === this.default_fromEmail || "team@deskera.com" || isSMTPEmail) {
      this.setState({
        isEmailVerified: true,
        emailBeingVerified: false,
        verificationMailSent: false,
      });
    } else if (!Utility.isValidEmail(email)) {
      this.setState({
        isEmailVerified: false,
        emailBeingVerified: false,
        verificationMailSent: false,
      });
    } else {
      this.setState({
        emailBeingVerified: true,
        isEmailVerified: false,
      });
      CampaignService.getEmailVerification(email).then((res) => {
        let isEmailVerified = false;
        let verificationMailSent = false;

        if (res.data && res.data.length > 0) {
          isEmailVerified = res.data.some((rec) => {
            const isMailSent =
              rec.tenant_id === UserManager.getUserTenantID() &&
              rec.email === email;
            verificationMailSent = verificationMailSent || isMailSent;
            return isMailSent && rec.is_verified;
          });
        }

        this.setState({
          isEmailVerified: isEmailVerified,
          verificationMailSent: verificationMailSent,
          emailBeingVerified: false,
        });
      });
    }
  }, 1000);

  showVerificationSent(message) {
    const buttons = [
      {
        title: "Cancel",
        className: "bg-gray1 border-m",
      },
      {
        title: "Resend",
        className: "bg-button text-white ml-r",
        onClick: () => this.sendVerificationEmail(true),
      },
    ];

    showAlert(
      message ? "Resend Email?" : "Email sent!",
      message || "Verification email has been sent, please check your inbox.",
      message ? buttons : null
    );

    this.setState({ verificationMailSent: true });
  }

  ///////////////////////////////////////////////////////////////////////////////////
  ///////////////////////////////////////////////////////////////////////////////////
  ///////////////////////////////////////////////////////////////////////////////////
  toggleSMTPselectionPicker(shouldOpen) {
    this.setState((prevState) => ({
      needSMTPPicker: shouldOpen ?? !prevState.needSMTPPicker,
    }));
  }

  handleSMTPSelection(smtpData) {
    if (!smtpData) return;

    this.toggleSMTPselectionPicker(false);
    this.dataChanged(smtpData.email, "fromEmail", true);
    this.dataChanged(smtpData.name, "fromName");
    this.dataChanged(smtpData.id, "campaignSetupId");
  }

  getSMTPSetupView(valueKey) {
    const { needSMTPPicker, smtpOptions } = this.state;

    return valueKey === "fromEmail" ? (
      <div className="position-relative">
        <div
          className="row width-auto cursor-hand"
          style={{
            pointerEvents: needSMTPPicker ? "none" : "all",
          }}
          onClick={() => this.toggleSMTPselectionPicker(true)}
        >
          <DKIcon src={DKIcons.ic_email} className="ic-xs ml-l" />
          <DKIcon src={DKIcons.ic_arrow_down} className="ic-xs ml-s" />
        </div>
        {needSMTPPicker ? (
          <DKListPicker
            title="SMTP"
            className="position-absolute border-m z-index-3"
            style={{ right: 0, top: 20, pointerEvents: "all", width: 200 }}
            data={[
              `${this.default_fromEmail} (default)`,
              ...smtpOptions.map((smtpOption) => smtpOption.email),
            ]}
            onSelect={(index, email) => {
              const selectedConfig =
                index === 0
                  ? {
                    email: this.default_fromEmail,
                    name: this.default_fromName,
                    id: this.default_smtp_setup_id,
                  }
                  : smtpOptions[index - 1];
              this.handleSMTPSelection(selectedConfig);
            }}
            onClose={() => this.toggleSMTPselectionPicker()}
            button={
              smtpOptions?.length > 4
                ? null
                : {
                  title: "Setup SMTP",
                  className: "bg-button text-white",
                  onClick: () => this.toggleSMTPselectionPopup(true),
                }
            }
            canEdit={true}
            onEdit={(index, email) => {
              if (index === 0) {
                showAlert("Error!", "Default SMTP cannot be changed");
                return
              }
              this.toggleSMTPselectionPopup(true);
              this.setState({ smtpDataToEdit: smtpOptions[index - 1] });
            }}
          />
        ) : null}
        {this.getSMTPPopup()}
      </div>
    ) : null;
  }

  getAllSMTPData() {
    SMTPService.getSetups().then((response) => {
      if (response && response.data && response.data.length > 0) {
        this.setState({ smtpOptions: response.data });
      }
    });
  }

  toggleSMTPselectionPopup(shouldOpen = null) {
    this.setState((prevState) => ({
      needSMTPPopup: shouldOpen ?? !prevState.needSMTPPopup,
    }));
  }

  getSMTPPopup() {
    return this.state.needSMTPPopup ? (
      <SmtpPopup
        data={this.state.smtpDataToEdit}
        onCancel={() => this.toggleSMTPselectionPopup(false)}
        onSave={(smtpData) => {
          this.toggleSMTPselectionPopup(false);
          this.handleSMTPSelection(smtpData);
          this.getAllSMTPData();
        }}
      />
    ) : null;
  }

  onSelectMailType = (type) => {
    let templateData = [];
    let showListPicker = false;
    const campaignTypeColId = TableManger.getColumnId(
      TABLES.CAMPAIGN,
      COLUMN_CODE.CAMPAIGN.CAMPAIGN_TYPE
    );
    if (type === TABLES.CAMPAIGN.toUpperCase()) {
      templateData = []
      showListPicker = true;
    } else if (type === TABLES.PEOPLE_EMAIL_TEMPLATE.toUpperCase()) {
      templateData = [];//
      showListPicker = true;
    }
    this.dataChanged(type, "bodySrcObjectType");
    this.setState({
      templateData,
      showListPicker,
      selectedTemplateJson: {},
      selectedTemplateName: this.state.emailTemplateList?.filter(template=>template.default).name,
    });
  };

  getAlert = () => {
    const buttons = [
      {
        title: "Cancel",
        className: "bg-gray1 border-m",
        onClick: () => {
          return;
        },
      },
      {
        title: "Leave",
        className: "bg-red text-white ml-r",
        onClick: () => {
          if (
            this.state.data.bodySrcObjectType === TABLES.CAMPAIGN.toUpperCase()
          ) {
            RouteManager.navigateToPage(PAGE_ROUTES.SELECT_CAMPAIGN_TEMPLATE);
          } else {
            RouteManager.navigateToPage(
              PAGE_ROUTES.EMAIL_TEMPLATE.LIST
            );
          }
        },
      },
    ];
    showAlert(
      "Leave Page?",
      "Are you sure want to leave this page? Your data will not be saved.",
      buttons
    );
  };

  convertToHtml = (jsonData) => {
    const htmlGenerator = new HtmlGenerator();
    let data = JSON.parse(Utility.decodeHTML(jsonData));
    const htmlData = htmlGenerator.getHTML(
      data.designElements,
      data.scripts,
      data.metaData,
      data.hash,
      PAGE_TYPE.CAMPAIGN
    );
    return data;
  };

  getNewBatch = () => {
    return (
      <div
        className="bg-blue text-white fs-xs position-absolute align-self-end p-h-xs"
        style={{ height: 12, marginTop: -2 }}
      >
        New
      </div>
    );
  };

  getListPicker = () => {
    return (
      <div className="ml-m">
        <DKButton
          className="bg-gray1 border-m border-radius-s"
          title={`${
            this.state.selectedTemplateName
              ? this.state.selectedTemplateName
              : "Select Template"
          }`}
          onClick={() => {
            this.toggleList(true);
          }}
          icon={DKIcons.ic_arrow_down2}
          isReverse={true}
        />
        <div className="z-index-1 position-relative parent-height">
          {this.state.toggleListPicker && (
            <DKListPicker2
              title="Select Template"
              data={
                this.state.templateData.length < 5
                  ? []
                  : this.state.templateData?.map(
                      (template) => template?.cells
                    ) || []
              }
              className="border-m shadow-l position-absolute width-auto email-dklistpicker2"
              style={{ top: 3, minWidth: 200 }}
              allowSearch={true}
              renderer={(index, obj) => (
                <DKLabel
                  text={`${
                    obj[
                      this.state.data.bodySrcObjectType ===
                      TABLES.CAMPAIGN.toUpperCase()
                        ? this.campaignNameColId
                        : this.landingPagesColId
                    ]
                  }`}
                />
              )}
              searchableKey={
                this.state.data.bodySrcObjectType ===
                TABLES.CAMPAIGN.toUpperCase()
                  ? this.campaignNameColId
                  : this.landingPagesColId
              }
              onSelect={(selectedIndex, selectedObj) => {
                this.toggleList();
                let data_formatted = {}
                data_formatted.data = {
                  _id: selectedObj.id,
                  cells: selectedObj,
                };
                LandingPageManager.setPageData(data_formatted);
                this.setState({
                  selectedTemplateJson: this.convertToHtml(
                    selectedObj[
                      this.state.data.bodySrcObjectType ===
                      TABLES.CAMPAIGN.toUpperCase()
                        ? this.campaignJsonColId
                        : this.landingPagesJsonColId
                    ]
                  ),
                  selectedTemplateName:
                    selectedObj[
                      this.state.data.bodySrcObjectType ===
                      TABLES.CAMPAIGN.toUpperCase()
                        ? this.campaignNameColId
                        : this.landingPagesColId
                    ],
                    // pageDesignerReadOnly:true
                });
                this.dataChanged(selectedObj["id"], "bodySrcRecordId");
              }}
              onClose={() => this.toggleList()}
              button={{
                title: "+ Add New Template",
                className: "bg-button text-white",
                onClick: () => {
                  this.getAlert();
                },
              }}
              searchApiConfig={{
                method: "POST",
                getUrl: (value) =>
                  `${
                    ApiConstants.URL.BASE
                  }${ApiConstants.URL.TABLE.GET_RECORD_BY_PAGE(
                    this.state.data.bodySrcObjectType ===
                      TABLES.CAMPAIGN.toUpperCase()
                      ? this.campaignTableId
                      : this.landingPageTableId
                  )}?q=${value}&pageSize=20`,
                getPayload: (search) => {
                  return this.state.data.bodySrcObjectType ===
                    TABLES.CAMPAIGN.toUpperCase()
                    ? {
                        logicalOperator: "and",
                        conditions: [
                          {
                            colId: TableManger.getColumnId(
                              TABLES.CAMPAIGN,
                              COLUMN_CODE.CAMPAIGN.CAMPAIGN_TYPE
                            ),
                            opr: FILTER_OPERATORS.NOT_EQUAL,
                            value: [CAMPAIGN_TYPE.WHATSAPP],
                          },
                        ],
                      }
                    : {};
                },
                dataParser: (response) =>
                  response.data?.map((template) => ({
                    ...template?.cells,
                    id: template._id,
                  })) || [],
                debounceTime: 300,
              }}
            />
          )}
        </div>
      </div>
    );
  };

  htmlBodyToDisplay(value) {
    if(!Utility.isEmpty(value) && this.state.data && !Utility.isEmpty(this.state.data['fromName'])) {
      value = value?.replaceAll('[Your Printed Name]',this.state.data['fromName'])
    }
    return value;
  }
  getEmailListPicker = () => {
    return (
      <div className="ml-m">
        <DKButton
          className="bg-gray1 border-m border-radius-s"
          title={`${this.state.selectedEmailTemplateName
              ? this.state.selectedEmailTemplateName
              : "Default Template"
            }`}
          onClick={() => {
            this.toggleList(true);
          }}
          icon={DKIcons.ic_arrow_down2}
          isReverse={true}
        />
        <div className="z-index-1 position-relative parent-height">
          {this.state.toggleListPicker && (
            <DKListPicker2
              title="Select Template"
              data={
                this.state.emailTemplateList
              }
              className="border-m shadow-l position-absolute width-auto email-dklistpicker2"
              style={{ top: 3, minWidth: 200 }}
              renderer={(index, obj) => (
                <DKLabel
                  text={`${obj['name']
                    }`}
                />
              )}
              searchableKey={
                'name'
              }
              onSelect={(selectedIndex, selectedObj) => {
                this.toggleList();
                if (this.state.selectedTemplateId !== selectedObj.id) {
                  let editor = document.getElementsByClassName('ql-editor');
                  if(editor && editor[0]) {
                    editor[0].innerHTML = ""
                  }
                  this.setState({
                    selectedEmailTemplateName: selectedObj.name,
                    data: {
                      ...this.state.data,
                      body: this.htmlBodyToDisplay(decodeBase64Uri(selectedObj.mailBody))
                    },
                    selectedTemplateId: selectedObj.id
                  })
                }
              }}
              onClose={() => this.toggleList()}
              button={{
                title: "+ Add New Template",
                className: "bg-button text-white",
                onClick: () => {
                  this.getAlert();
                },
              }}
              allowSearch={true}
              searchApiConfig={{
                method: "POST",
                getUrl: (value) =>
                  `${
                    ApiConstants.URL.BASE
                  }${ApiConstants.URL.TABLE.GET_RECORD_BY_PAGE(TableManger.getTableId(TABLES.PEOPLE_BASIC_EMAIL_TEMPLATE))}?q=${value}&pageSize=20`,
                getPayload: (search) => {
                  const statusColId = TableManger.getColumnId(
                    TABLES.PEOPLE_BASIC_EMAIL_TEMPLATE,
                    COLUMN_CODE.PEOPLE_BASIC_EMAIL_TEMPLATE.STATUS
                  )
                  let payload = {"logicalOperator":"and","conditions":[{"colId":statusColId,"value":[1],"opr":"c"}]}
                  return payload;
                },
                dataParser:(res) =>{
                  if(res.data) {
                    return res.data.map((row,index)=>{
                      return {
                        ...row?.cells,
                        id: row._id,
                        name: row.cells[TableManger.getColumnId(
                          TABLES.PEOPLE_BASIC_EMAIL_TEMPLATE,
                          COLUMN_CODE.PEOPLE_BASIC_EMAIL_TEMPLATE.NAME
                        )],
                        mailBody: row.cells[TableManger.getColumnId(
                          TABLES.PEOPLE_BASIC_EMAIL_TEMPLATE,
                          COLUMN_CODE.PEOPLE_BASIC_EMAIL_TEMPLATE.HTML_DATA
                        )],
                        active: row.cells[TableManger.getColumnId(
                          TABLES.PEOPLE_BASIC_EMAIL_TEMPLATE,
                          COLUMN_CODE.PEOPLE_BASIC_EMAIL_TEMPLATE.STATUS
                        )],
                        default: row.cells[TableManger.getColumnId(
                          TABLES.PEOPLE_BASIC_EMAIL_TEMPLATE,
                          COLUMN_CODE.PEOPLE_BASIC_EMAIL_TEMPLATE.DEFAULT
                        )]
                      }
                    })
                  } else {
                    return []
                  }
                },
                debounceTime: 300,
              }}
            />
          )}
        </div>
      </div>
    );
  }
}

export default EmailComposer;
